export default class {
    constructor(Component) {
        this.Component  = Component;
        this.container  = Component.container.querySelector('.box-listing-pagination');
        this.offset     = 0;
    }

    get rows() {
        switch (this.Component.layout) {
            case 'list':
                return 1000;
            case 'slider':
                return 1;
            default:
                return this.Component.container.dataset.rows || 1000;
        }
    }

    get columns() {
        const viewPoint = App.Interface.Breakpoint.getFromWidth(this.Component.width);
        const columns   = this.Component.wrap.parentElement.dataset['column' + App.Utilities.String.capitalize(viewPoint)];
        return columns || 3;
    }

    get max() {
        return this.columns * this.rows;
    }
}
